import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getActiveSkiSuppliers() {
    return conduit.get('products/products/suppliers/ski/active');
  },
  /**
   * @returns {AxiosPromise}
   */
  getSkiSitesWithAreaAndCountry() {
    return conduit.get('products/products/sites/ski/with-area-and-country');
  },

  getPickupPlaces(payload) {
    return conduit.get(`ski/pickups/seasons/skipass/${payload}`);
  },

  updateSeasonPickupPlaces(payload) {
    return conduit.put(`ski/pickups/seasons/skipass/${payload.seasonId}`, payload.ids);
  },

  getSkiRentalPickupPlaces(payload) {
    return conduit.get(`ski/pickups/seasons/skirental/${payload}`);
  },

  updateSkiRentalPickupPlaces(payload) {
    return conduit.put(`ski/pickups/seasons/skirental/${payload.seasonId}`, payload.ids);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-service.js